import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BolddeskComponent } from './bolddesk.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BolddeskComponent],
  exports: [BolddeskComponent]
})
export class BolddeskModule {}
